import { render, staticRenderFns } from "./GoogleWithLogin.vue?vue&type=template&id=38bd53ba&"
import script from "./GoogleWithLogin.vue?vue&type=script&lang=js&"
export * from "./GoogleWithLogin.vue?vue&type=script&lang=js&"
import style0 from "./GoogleWithLogin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports